import type { Formatters, Locales } from '@/shared/i18n/i18n-types'
import type { FormattersInitializer } from 'typesafe-i18n'

import { lowercase } from 'typesafe-i18n/formatters'

export const initFormatters: FormattersInitializer<Locales, Formatters> = (_locale: Locales) => {
  const formatters: Formatters = {
    lower: lowercase,
  }

  return formatters
}
